exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-sm { margin-top: 10px; }\r\n.transaction-charges { margin: auto; }\r\n.link-tnc { text-decoration: underline; cursor: pointer;color: steelblue; display: inline-block; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/prepaid-balance/prepaid-balance.component.css
// module id = ../../../../../src/app/components/prepaid-balance/prepaid-balance.component.css
// module chunks = 0